import * as $ from "jquery";
import { BookmarkService } from "../../services/bookmarkService";
import { CategoriesService } from "../../services/categoriesService";
import { connectEventToState, eventListeners } from '../../react-features/sidebar-bookmarks/connectEventToState';
import { store } from '../../react-features/sidebar-bookmarks/redux/store';
import { actionCreators } from '../../react-features/sidebar-bookmarks/redux/actions';
import { sendEvent } from "../helpers/Analytics";


export function initialize(): void {
    wireClickEvent();
}

const activeClass: string = 'js-active';
const service: BookmarkService = new BookmarkService();
const bookmarkCategoryService: CategoriesService = new CategoriesService();

/**
 * The following code is used to tie existing jQuery functionality with the Redux state.
 * By emitting events that hook into `actionCreators`, we can keep the existing jQuery,
 * while still updating the new React features' Redux state. 
 * */
let selectedBookmark;
const addBookmarkEvent = connectEventToState.create(eventListeners.addBookmark, document.querySelector('.js-bookmark'), (event) => {
    if (event) {
        event.preventDefault();
    }
    if (selectedBookmark) {
        sendEvent('bookmark', undefined, { pageTitle: selectedBookmark.pageTitle })
        store.dispatch(actionCreators.toggleTooltip());
        store.dispatch(actionCreators.setSelectedBookmarkId(selectedBookmark.id));
        store.dispatch(actionCreators.setEditedBookmarkName(selectedBookmark.pageTitle));
        store.dispatch(actionCreators.setSelectedCategoryId(selectedBookmark.categoryId));

        store.dispatch(actionCreators.addBookmark(selectedBookmark))
    }
    updateBookmarkList();
})
const deleteBookmarkEvent = connectEventToState.create(eventListeners.deleteBookmark, document.querySelector('.js-bookmark'), (event) => {
    if (event) {
        event.preventDefault();
    }

    if (selectedBookmark) {
        store.dispatch(actionCreators.setSelectedBookmarkId(''));
        store.dispatch(actionCreators.deleteBookmark(selectedBookmark))
    }
    updateBookmarkList();
})

function wireClickEvent(): void {
    $('.js-bookmark').on('click', handleClick);
}

// update bookmarkevent
function updateBookmarkList(){
    try{
        bookmarkCategoryService.getCategories(
            (data) => {
                if (data) {
                store.dispatch(actionCreators.populateCategories(data));
                }
            },
            (error) => {
                console.error({ error });
            }
        );
 
    }catch(e){
        console.error(e);
    }
}

function handleClick(e: any): void {
    e.preventDefault();

    const $this = $(this);
    const isActive = $this.hasClass(activeClass);
    const contentId = this.dataset.contentid;

    if (isActive) {
        service.deleteBookmarkForPage(contentId, (response) => {
            $this.removeClass(activeClass)
            $this.attr("title", "Favoritmarkera dokumentet");
            // This is fragile. See comment about events in top of file.
            // DO NOT REMOVE. Will break React state.
            const pageId = parseInt(contentId, 10);
            if (pageId) {
                selectedBookmark = pageId;
                document.querySelector('.js-bookmark').dispatchEvent(deleteBookmarkEvent);
            }
        }, (response) => { alert("Tillfälligt fel: Kan inte ta bort favorit") });
    }
    else {
        service.createBookmarkForPage(contentId, (response) => {
            $this.addClass(activeClass)
            $this.attr("title", "Ta bort favoritmarkering");
            // This is fragile. See comment about events in top of file.
            // DO NOT REMOVE. Will break React state.
            if (response) {
                selectedBookmark = response;
                const pageId = parseInt(contentId, 10);
                if (pageId === response.pageId) {
                    document.querySelector('.js-bookmark').dispatchEvent(addBookmarkEvent);
                }
            }
        }, (response) => { alert("Tillfälligt fel: Kan inte skapa favorit") });
    }
    
    $this.blur();
}